import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {fetchEndpointIfNeeded as ftch} from '../actions/fetch'
import TableForm from './utilities/TableForm'
import { CSSTransition } from "react-transition-group"
import {Link} from 'react-router-dom'


class EndpointTable extends Component{
    constructor(props){
        super(props)
        this.sb = props.sidebar
    }

    breadCrumb = () => {
        let breadCrumb = window.location.href.split('/')
        return breadCrumb
    }


    componentDidMount()
    {
        let sb = this.sb
        if( sb && sb.endpointId ) {
            this.props.dispatch(
                ftch(sb.endpointId)
            )
        } 
    }

    render(){
        let ep = this.props.endpoints.find(e => 
            e.id === this.sb.endpointId)
        let list = ep.list
        let ac = this.props.auth.access_token

        return (
        <div className="component-title list-group" id="working-area">
            <div className="list-group-item list-group-item-action gradient-background">
                <div className="pull-left" id="endpoint-label-wrapper">
                
                    <div className="breadcrumbs sticky-bread-crumbs"> 
                    <div className="mt-1 float-left">
                        <p>
                            <Link to={'/'}><i className="fas fa-th"></i>Dashboard</Link> 
                            <i className="fas fa-arrow-right"></i>
                            <Link to={`/${this.breadCrumb()[3]}`}>{this.breadCrumb()[3]}</Link>
                            {/* <i className="fas fa-arrow-right"></i> */}
                            
                        </p>
                    </div>

                    </div>
                    {/* <div className="float-right">
                    <Link to={`/${sb.label}/new`}>
                        <button className="btn btn-custom add-btn"><i className="fas fa-plus"></i> Add new {sb.label.replace('ies', 'ys').slice(0, -1)}</button>
                    </Link>
                    </div> */}
                </div>
                

                
                
            </div>
            <CSSTransition
                in={true}
                appear={true}
                timeout={500}
                classNames="fade"
            >
           
                <div className="" id="working-view">
                <div className="prop-details">
                {
                    list.length ?
                    <TableForm 
                        
                        list={list}
                        endpoint={ep}
                        access={ac}
                        colsCfg={this.sb.config.displayColumns}
                        


                    />:
                    // 'Loading ... '
                    <div className="spinner-overlay">
                        <i class="fa fa-spinner fa-spin"></i>
                    </div>
                }
                </div>
                </div>
          
            </CSSTransition>
        </div>
        )
    }
}

function mapStateToProps(state)
{
    return {
        endpoints: state.endpoints,
        auth: state.auth
    }
}

export default withRouter(connect(mapStateToProps)(EndpointTable))


// import React, {Component} from 'react'
// import {withRouter} from 'react-router-dom'
// import {connect} from 'react-redux'
// import {fetchEndpointIfNeeded as ftch} from '../actions/fetch'
// import {Formik} from 'formik'
// import { CSSTransition } from "react-transition-group"

// import TableForm from './utilities/TableForm'

// class EndpointTable extends Component{
//     constructor(props){
//         super(props)
//         this.sb = props.sidebar
//     }

//     componentDidMount()
//     {
//         let sb = this.sb
//         if( sb && sb.endpointId ) {
//             this.props.dispatch(
//                 ftch(sb.endpointId)
//             )
//         } 
//     }

//     render(){
//         let cols = this.cols
//         let sb = this.sb
//         let colsCfg = this.colsCfg
//         let { endpoints } = this.props
//         let list = endpoints.find(e => 
//             e.id === sb.endpointId).list
//         let initVal = {}
//         if(list.length > 0){
//             list.forEach((l,i) => {
//                 for(var n in l){
//                     initVal[n + '>>' + i] = l[n]
//                 }
//             })
//         }  
//         let newList = list.concat([
//             {model: "", property: "", accessType: "", permission: "", principalType: "", property: ""}
//         ])
//         return (

//             <CSSTransition
//                 in={true}
//                 appear={true}
//                 timeout={500}
//                 classNames="fade"
//             >
//             <div className="container mt-5 mb-5">
//                 {
//                     list && Object.keys(list).length && 
//                     // <Formik
//                     //     initialValues={ initVal }
//                     //     onSubmit={values => {

//                     //         // Do not mutate the state. Create a new array.
//                     //         let finalValues = newList.concat([])
//                     //         for(var n in values){
//                     //             let ndx = Number(n.split('>>')[1])
//                     //             let prp = n.split('>>')[0]
//                     //             finalValues[ndx][prp] = values[n]
//                     //         }

//                     //     }}
//                     //     render={({
//                     //         handleSubmit,
//                     //         handleChange,
//                     //         values
//                     //     }) =>
//                     //         {
//                     //             return (
//                     //                 <form  id="form-acl">
//                     //                     <table className="table table-light" id="table-acl">
//                     //                         <tbody>
//                     //                             <tr>
//                     //                                 {this.cols.map(c => <th key={c}>{c}</th>)}
//                     //                             </tr>
//                     //                             <button 
//                     //                                 type="button"
//                     //                                 onClick={this.createNew}
//                     //                                 className="btn btn-custom add-btn mr-2 ml-3 mb-3 mt-4"
//                     //                             >
//                     //                             <i className="fas fa-plus"></i> New
//                     //                             </button>
//                     //                             <button 
//                     //                                 type="submit"
//                     //                                 onClick={handleSubmit}
//                     //                                 className="btn btn-success mb-3 mt-4"
//                     //                             >
//                     //                                 Save
//                     //                             </button>
//                     //                             {
                                                    
//                     //                                 newList.map( (l,i) => <tr key={i}>
//                     //                                     {
//                     //                                         Object.keys(l).map(k => {
//                     //                                             if(cols.indexOf(k) !== -1) {
//                     //                                                 return <td key={k+'>>'+i}>
//                     //                                                     {
//                     //                                                         colsCfg[k].type === 'string' ?
//                     //                                                         <input 
//                     //                                                             name={k+'>>'+i}
//                     //                                                             onChange={handleChange} 
//                     //                                                             value={values[k+'>>'+i]}
//                     //                                                             className="form-control"
//                     //                                                         />: 
//                     //                                                         <select 
//                     //                                                             name={k+'>>'+i}
//                     //                                                             onChange={handleChange} 
//                     //                                                             value={values[k+'>>'+i]}
//                     //                                                             className="form-control"
//                     //                                                         >
//                     //                                                             {
//                     //                                                                 colsCfg[k].values.map( (v,j)=>
//                     //                                                                     <option 
//                     //                                                                         key={k+'>>'+i+'>>'+j}
//                     //                                                                         value={colsCfg[k].values[j]}
//                     //                                                                     >
//                     //                                                                         {colsCfg[k].values[j]}
//                     //                                                                     </option>
//                     //                                                                 )
//                     //                                                             }
//                     //                                                         </select>                                                                            
//                     //                                                     }
//                     //                                                 </td>
//                     //                                             }
//                     //                                             return null
//                     //                                         })
//                     //                                     }
//                     //                                 </tr>)
//                     //                             }
//                     //                         </tbody>
//                     //                     </table>
//                     //                     <button 
//                     //                         type="button"
//                     //                         onClick={this.createNew}
//                     //                         className="btn btn-custom add-btn mr-2 ml-3 mb-5"
//                     //                     >
//                     //                     <i className="fas fa-plus"></i> New
//                     //                     </button>
//                     //                     <button 
//                     //                         type="submit"
//                     //                         onClick={handleSubmit}
//                     //                         className="btn btn-success mb-5"
//                     //                     >
//                     //                         Save
//                     //                     </button>
//                     //                 </form>
//                     //             )
//                     //         }
//                     //     }
//                     // />
//                 }
//             </div>
//             </CSSTransition>
//         )
//         let ep = this.props.endpoints.find(e => 
//             e.id === this.sb.endpointId)
//         let list = ep.list
//         let ac = this.props.auth.access_token

//         return <div>
//             {
//                 list.length ?
//                 <TableForm 
//                     list={list}
//                     endpoint={ep}
//                     access={ac}
//                     colsCfg={this.sb.config.displayColumns}
//                 />:
//                 'Loading ... '
//             }
//         </div>
//     }
// }

// function mapStateToProps(state)
// {
//     return {
//         endpoints: state.endpoints,
//         auth: state.auth
//     }
// }

// export default withRouter(connect(mapStateToProps)(EndpointTable))


// WEBPACK FOOTER //
// ./src/components/endpointTable.js